import { render, staticRenderFns } from "./AddFileModal.vue?vue&type=template&id=2c2451ff&scoped=true&"
import script from "./AddFileModal.vue?vue&type=script&lang=js&"
export * from "./AddFileModal.vue?vue&type=script&lang=js&"
import style0 from "./AddFileModal.vue?vue&type=style&index=0&id=2c2451ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2451ff",
  null
  
)

export default component.exports